export const isRefundManager = self =>
  self.roles.some(ur => ur.role === "refund_manager");

export const isPaymentPlanManager = self =>
  self.roles.some(ur => ur.role === "payment_plan_manager");
